<sh-page>
  <sh-splash-screen
  modal
  label="{{ 'label.ib.overview' | translate }}" version="Version 1.0"
  image="url('../../assets/loginpage_Image.png')"
> 
    <sh-button label="Log In" (click)="onLoginClick()"></sh-button>
    <sh-text slot="info" size="body-2" color="secondary"
      >{{ 'copyright.siemens' | translate }}</sh-text
    >
  </sh-splash-screen>
<sh-page>